import { Panel, Placeholder } from "rsuite";

type NoCompanySelectedProps = {
    isLoading?: boolean;
};

export function NoCompanySelected({
    isLoading = false,
}: NoCompanySelectedProps) {
    return (
        <div
            style={{
                display: "grid",
                placeItems: "center",
                padding: 24,
            }}
        >
            <Panel
                bordered
                header="Nenhuma empresa selecionada"
                style={{
                    maxWidth: 520,
                    width: "100%",
                    borderRadius: 12,
                }}
                bodyFill
            >
                {isLoading ? (
                    <div style={{ padding: 24 }}>
                        <Placeholder.Graph active height={90} />
                        <Placeholder.Paragraph active rows={2} />
                    </div>
                ) : (
                    <div style={{ padding: 24, textAlign: "center" }}>
                        <div
                            style={{
                                fontSize: 16,
                                lineHeight: 1.6,
                                marginBottom: 16,
                                color: "var(--rs-text-secondary)",
                            }}
                        >
                            Para continuar, selecione a empresa com a qual deseja trabalhar.
                            Você pode trocar a empresa a qualquer momento.
                        </div>
                    </div>
                )}
            </Panel>
        </div>
    );
}
